import { Input } from "antd";
import PropTypes from "prop-types";

import classnames from "classnames";
import { useState } from "react";
import { MdCheck, MdPriorityHigh, MdLock } from "react-icons/md";
import Label from "shared/components/Label";
import {
  filterTextField,
  normalizeTextField,
  stripTrailingSpaces,
} from "utils/helpers/validations";

const Custom = ({
  label,
  placeholder,
  errors,
  touched,
  icon,
  innerRef,
  required,
  direction,
  optional,
  right,
  trim = false,
  stripSpaces = false,
  normalizeText = false,
  uppercase = false,
  success = false,
  showSuccessIcon = true,
  onChange = () => {},
  value: valueProp,
  defaultValue,
  onBlur,
  className = "",
  ...inputRest
}) => {
  const [internalVal, setInternalVal] = useState(defaultValue ?? "");
  const isControlled = valueProp !== undefined;
  const val = isControlled ? (valueProp ?? "") : internalVal;

  const applyValue = (rawValue) => {
    let next = rawValue || "";
    if (stripSpaces) next = next.replace(/\s/g, "");
    if (normalizeText) next = filterTextField(next);
    if (trim) next = next.replace(/[^a-z0-9]/gi, "");
    if (uppercase) next = next.toUpperCase();
    return next;
  };

  const commitValue = (next, e) => {
    if (!isControlled) setInternalVal(next);
    if (e) {
      e.target.value = next;
      onChange({ ...e, target: { ...e.target, value: next } });
    }
  };

  return (
    <div
      className={classnames(
        "input__wrapper",
        {
          __error: touched && errors,
          __success: success && !errors,
        },
        direction,
      )}
    >
      <Label
        label={label}
        icon={icon}
        required={required}
        optional={optional}
        right={right}
      />
      <div className={`input__wrapper--field`}>
        <Input
          {...inputRest}
          value={val}
          className={classnames(className, {
            "input--borderd--red": touched && errors,
            "disable--input": inputRest.disabled,
          })}
          placeholder={placeholder}
          ref={innerRef}
          onChange={(e) => {
            commitValue(applyValue(e.target.value), e);
          }}
          onBlur={(e) => {
            let next = applyValue(e.target.value);
            if (normalizeText) next = normalizeTextField(next);
            next = stripTrailingSpaces(next);
            if (next !== val) commitValue(next, e);
            onBlur?.(e);
          }}
        />

        {touched && errors && (
          <MdPriorityHigh className="input--error-icon" size={20} />
        )}

        {success && showSuccessIcon && !errors && (
          <MdCheck className="input--success-icon" size={20} />
        )}

        {inputRest.disabled && !touched && (
          <MdLock className="input--disabled-icon" size={16} />
        )}
      </div>
      {touched && errors && <p className={"input--errors"}>{errors}</p>}
    </div>
  );
};

Custom.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

Custom.defaultProps = {
  label: "",
  placeholder: "",
};
export default Custom;
